import React from "react";
import { Box, Flex, Text } from "@telia/teddy";
import { type FeedbackEntry } from "./feedbackTypes";
import "./ReviewCard.less";

const formatDate = (iso: string) =>
    new Date(iso).toLocaleDateString("nb-NO", { day: "2-digit", month: "2-digit", year: "numeric" });

const ScoreBadge: React.FC<{ score: number }> = ({ score }) => {
    const stars = "★".repeat(score) + "☆".repeat(5 - score);
    return <Text className="review-score-badge">{stars}</Text>;
};

const HighlightedText: React.FC<{ text: string; query: string }> = ({ text, query }) => {
    if (!query) return <>{text}</>;
    const escaped = query.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    const parts = text.split(new RegExp(`(${escaped})`, "gi"));
    const lowerQuery = query.toLowerCase();
    return (
        <>
            {parts.map((part, i) =>
                part.toLowerCase() === lowerQuery ? (
                    <mark key={i} className="review-highlight">
                        {part}
                    </mark>
                ) : (
                    part
                ),
            )}
        </>
    );
};

type Props = {
    entry: FeedbackEntry;
    searchQuery?: string;
};

const ReviewCard: React.FC<Props> = ({ entry, searchQuery = "" }) => (
    <Box className="review-card review-card--review">
        <Flex direction="row" justify="between" className="review-card__header">
            <Flex direction="row" gap="200" wrap="wrap" className="review-card__header-badges">
                {entry.score !== null && <ScoreBadge score={entry.score} />}
            </Flex>
            <Text className="review-card__date">{formatDate(entry.createdAt)}</Text>
        </Flex>
        {entry.description && (
            <Box className="review-card__description review-card__description--review">
                <Text className="review-card__description-text">
                    <HighlightedText text={entry.description} query={searchQuery} />
                </Text>
            </Box>
        )}
        <Flex direction="row" gap="400" wrap="wrap">
            {entry.agentName && <Text className="review-card__meta-text">Agent: {entry.agentName}</Text>}
            {entry.dealerName && (
                <Text className="review-card__meta-text">
                    Forhandler: {entry.dealerName}
                    {entry.dealerCode ? ` (${entry.dealerCode})` : ""}
                </Text>
            )}
            {entry.orderRef && <Text className="review-card__meta-text">Ordre: {entry.orderRef}</Text>}
        </Flex>
    </Box>
);

export default ReviewCard;
